"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryoSleep = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var Card_1 = require("../Card");
var CardRenderer_1 = require("../render/CardRenderer");
var CryoSleep = (function (_super) {
    __extends(CryoSleep, _super);
    function CryoSleep() {
        return _super.call(this, {
            cost: 10,
            tags: [Tags_1.Tags.SCIENCE],
            name: CardName_1.CardName.CRYO_SLEEP,
            cardType: CardType_1.CardType.ACTIVE,
            metadata: {
                cardNumber: 'C07',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.effect('When you trade, you pay 1 less resource for it.', function (be) {
                    be.trade().startEffect.tradeDiscount(1);
                }); }),
                victoryPoints: 1,
            },
        }) || this;
    }
    CryoSleep.prototype.play = function (player) {
        player.colonyTradeDiscount++;
        return undefined;
    };
    CryoSleep.prototype.getVictoryPoints = function () {
        return 1;
    };
    CryoSleep.prototype.onDiscard = function (player) {
        player.colonyTradeDiscount--;
    };
    return CryoSleep;
}(Card_1.Card));
exports.CryoSleep = CryoSleep;
